import { AxiosRequestConfig, AxiosResponse } from 'axios';
import getCsrfTokenFromCookie from "@/util/csrf-token";
import client from "@/util/client";


// APIリクエストをラップする関数
const apiRequest = async (config: AxiosRequestConfig): Promise<AxiosResponse<any>> => {
    try {
        // CSRFトークンを取得してヘッダーに追加
        const csrfToken = getCsrfTokenFromCookie(document.cookie);
        // デフォルトのheadersを設定
        const defaultHeaders = {
            'Content-Type': 'application/json',
            'X-CSRFToken': csrfToken,
            'X-App-Version': import.meta.env.VITE_FRONTEND_APP_VERSION,
        };
        // configオブジェクトのheadersが存在しない場合、デフォルトのヘッダーを設定する
        if (!config.headers) {
            config.headers = defaultHeaders;
        }
        // APIリクエストを送信する
        const response = await client(config);
        return response; 
    } catch (error) {
        throw error;
    }
};

export default apiRequest